import { BcsProductKey } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.model';

import type { SecondaryRealtimePrice } from './realtime.model';

export type SecondaryMarketRealtimeActions =
  | SecondaryMarketPriceReceived
  | SecondaryMarketPriceCleared
  | SecondaryMarketPriceKeptAlive
  | SecondaryMarketPriceKeepAliveFailed
  | SecondaryMarketPriceSubscribed
  | SecondaryMarketPriceSubscribeFailed
  | SecondaryMarketPriceUnsubscribeFailed;

/////////////////////////////////////////////
export function secondaryMarketPriceReceived(bcsProductKey: BcsProductKey, price: SecondaryRealtimePrice) {
  return {
    type: 'SECONDARY_MARKET_PRICE_RECEIVED' as const,
    bcsProductKey,
    price,
  };
}

export type SecondaryMarketPriceReceived = ReturnType<typeof secondaryMarketPriceReceived>;

/////////////////////////////////////////////
export function secondaryMarketPriceCleared(bcsProductKey: BcsProductKey) {
  return {
    type: 'SECONDARY_MARKET_PRICE_CLEARED' as const,
    bcsProductKey,
  };
}

export type SecondaryMarketPriceCleared = ReturnType<typeof secondaryMarketPriceCleared>;

/////////////////////////////////////////////

export function secondaryMarketPriceUnsubscribeFailed(bcsProductKey: BcsProductKey) {
  return {
    type: 'SECONDARY_MARKET_PRICE_UNSUBSCRIBE_FAILED' as const,
    bcsProductKey,
  };
}

export type SecondaryMarketPriceUnsubscribeFailed = ReturnType<typeof secondaryMarketPriceUnsubscribeFailed>;

/////////////////////////////////////////////
export function secondaryMarketPriceKeptAlive(bcsProductKeys: BcsProductKey[]) {
  return {
    type: 'SECONDARY_MARKET_PRICE_KEPT_ALIVE' as const,
    bcsProductKeys,
  };
}

export type SecondaryMarketPriceKeptAlive = ReturnType<typeof secondaryMarketPriceKeptAlive>;

/////////////////////////////////////////////
export function secondaryMarketPriceKeepAliveFailed(bcsProductKeys: BcsProductKey[]) {
  return {
    type: 'SECONDARY_MARKET_PRICE_KEEP_ALIVE_FAILED' as const,
    bcsProductKeys,
  };
}

export type SecondaryMarketPriceKeepAliveFailed = ReturnType<typeof secondaryMarketPriceKeepAliveFailed>;

/////////////////////////////////////////////

export function secondaryMarketPriceSubscribed(bcsProductKey: BcsProductKey) {
  return {
    type: 'SECONDARY_MARKET_PRICE_SUBSCRIBED' as const,
    bcsProductKey,
  };
}

export type SecondaryMarketPriceSubscribed = ReturnType<typeof secondaryMarketPriceSubscribed>;

/////////////////////////////////////////////

export function secondaryMarketPriceSubscribeFailed(bcsProductKey: BcsProductKey) {
  return {
    type: 'SECONDARY_MARKET_PRICE_SUBSCRIBE_FAILED' as const,
    bcsProductKey,
  };
}

export type SecondaryMarketPriceSubscribeFailed = ReturnType<typeof secondaryMarketPriceSubscribeFailed>;
